module.exports = __webpack_public_path__ + "media/young-link.f39b689e.wav";